<template>
  <v-data-table
    class="no-border"
    :items="data"
    :headers="headers"
    :items-per-page="data.length + 1"
    hide-default-footer
    hide-default-header
    sort-by="ratio"
    :sort-desc="false"
    :loading="loading"
    dense
    no-data-text="Aucun produit en alerte"
  >
    <template v-slot:item="{ item }">
      <tr>
        <td style="padding: 2px;">
          <v-row align="center" dense no-gutters>
            <v-col cols="5">
              <a
                style="cursor: pointer; color:rgba(0, 0, 0, 0.87);"
                @click="goToDetails(item.product)"
                class="font-capitalize caption"
              >
                {{ item.name }}</a
              ></v-col
            >
            <v-col cols="5" sm="6">
              <div class="progress-chart">
                <v-progress-linear
                  :color="getColor(item)"
                  :background-color="getColor(item)"
                  :background-opacity="item.ratio === 0 ? 1 : 0.3"
                  height="30px"
                  rounded
                  :value="item.ratio"
                >
                  <template v-slot="{ value }">
                    <v-row
                      v-if="item.ratio <= 100"
                      alin="center"
                      justify="space-between"
                      no-gutters
                      class="px-3"
                    >
                      <div style=" color: #fff; height: 20px; padding: 0 2px;">
                        {{ item.qty_display }}
                        <span class="caption ml-1">{{ item.unit }}</span>
                      </div>
                    </v-row>
                  </template>
                </v-progress-linear>
              </div>
            </v-col>
            <v-col cols="2" sm="1">
              <v-row justify="end" no-gutters dense>
                <!-- <v-chip
                  label
                  class="ml-2 block-chip"
                  :color="item.ratio === 0 ? 'error' : ''"
              
                > -->
                <span class="caption" @click="openEditor(item)">{{
                  item.quantity
                }}</span>
                <!-- </v-chip> -->
                <InventoryAlertEditor
                  @update="getData()"
                  :data="item"
                  :ref="`editor${item.id}`"
                ></InventoryAlertEditor>
              </v-row>
            </v-col>
          </v-row>
        </td>
      </tr>
    </template>
  </v-data-table>
</template>

<script>
import { api } from "@/api";
import { mapGetters } from "vuex";
import { round10 } from "round10";
import { InventoryAlertEditor } from "@/modules/Inventory/components";
export default {
  name: "InventoryWarningChart",
  components: {
    InventoryAlertEditor
  },
  computed: {
    ...mapGetters([
      "getInventoryRecords",
      "getPreparationSlipTemplates",
      "getProducts"
    ])
  },
  mounted() {
    this.getData();
  },
  data() {
    return {
      loading: false,
      data: [],
      headers: [
        {
          value: "quantity",
          align: "end",
          class: "pa-0",
          sortable: false
        }
      ]
    };
  },
  methods: {
    async getData() {
      try {
        this.loading = true;
        await Promise.all([
          this.$store.dispatch("loadInventoryRecords", {
            store: this.getStoreId,
            latest: true
          })
        ]);
        const d = await api.getInventoryAlerts();
        this.data = d
          .map(x => this.mapData(x))
          .filter(x => x.computedQuantity !== null && x.ratio < 100);
      } finally {
        this.$emit("update");
        this.loading = false;
      }
    },
    mapData(item) {
      const record = this.getInventoryRecords.find(
        x => x.fk_product === item.product
      );
      if (record) {
        const product = this.getProducts.find(x => x.id === item.product);
        if (product) {
          const diff = round10(
            Number(record.computedQuantity) - item.quantity,
            0
          );
          const ratio =
            item.quantity != 0
              ? (round10(+record.computedQuantity, 0) / item.quantity) * 100
              : 100;
          return {
            ...item,
            name: product.nom,
            quantity: Number(item.quantity),
            computedQuantity: record.computedQuantity,
            qty_display: round10(Number(record.computedQuantity), 0),
            diff: diff,
            ratio: ratio,
            unit: product.data ? product.data.unite_mesure_inventory : ""
          };
        }
      }
      return {
        ...item,
        quantity: Number(item.quantity),
        computedQuantity: null,
        diff: null,
        ratio: null,
        unit: ""
      };
    },
    goToDetails(id) {
      this.$router.push({ name: "StatisticsDetails", params: { id: id } });
    },
    getColor(item) {
      const ratio = item.ratio;
      if (ratio > 0) {
        if (ratio >= 100) {
          return "success";
        }
        return "warning";
      }
      return "error";
    },
    openEditor(item) {
      if (this.$refs[`editor${item.id}`] !== undefined) {
        this.$refs[`editor${item.id}`].open();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.progress-chart {
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: nowrap;
}
.product-td {
  max-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
